import Vuex from 'vuex';
import Vue from 'vue'
import Router from "vue-router"
import createPersistedState from 'vuex-persistedstate'
//vuex,不能用this.$http,需要按需引入
import { getuserinfo,getMenu } from '../api';
Vue.use(Vuex)
export default new Vuex.Store({
	state:{
		userInfo:{},//保存用户信息
		menusList:[],
	},
	mutations:{
		updateUserInfo(state,getuseInfo){
			state.userInfo = getuseInfo
		},
		updateMenu(state,getMenu){
			state.menusList = getMenu
		},

	},
	 actions:{//请求接口
		// //请求->用户信息
	 async getUserInfoActions(store){
		 const { data: res } = await getuserinfo()
		if(res.status === 0){
			store.commit('updateUserInfo',res.data)
		}
		},
		async getMenus(store){
      return new Promise(async (resolve)=>{
        const { data: res } = await getMenu()
        if(res.status === 0){
        	store.commit('updateMenu',res.data)
        }
        resolve()
        })

			}
	},
	getters:{
		username:(state) =>{
			return state.userInfo.username
		},
		nickname:(state) =>{
			return state.userInfo.nickname
		},
		user_pic:(state) =>{
			return state.userInfo.user_pic
		},
		statesw:(state) =>{
			return state.userInfo.statesw
		},
		id:(state)=>{
			return state.userInfo.id
		},
		menusList:(state)=>{
			return state.menusList
		}
	},
	plugins:[
		createPersistedState()//注入持久化插件
	]
})
